<template>
  <BaseModal
    :modalProps="{ size: 'lg', 'no-close-on-backdrop': true }"
    title="References"
    data-testid="ReferencesModalModal"
  >
    <template #trigger="{ onOpen }">
      <span v-if="candidate.referrals || candidate.website">
        <b-link
          v-if="link"
          href="#"
          data-testid="references-modal-trigger"
          @click.prevent="onOpen"
        >
          <span class="d-inline">View</span>
        </b-link>
        <b-button
          v-else
          variant="primary"
          data-testid="references-modal-trigger"
          @click.prevent="onOpen"
        >
          <span class="d-inline">View</span>
        </b-button>
      </span>
      <span v-else>-</span>
    </template>

    <template #default="{ onClose }">
      <ReferencesModalContent :onClose="onClose" :candidate="candidate" />
    </template>

    <template #footer="{ onClose }">
      <BaseModalControls :onOk="onClose" />
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal/BaseModal'
import BaseModalControls from '@/components/BaseModal/BaseModalControls/BaseModalControls'
import ReferencesModalContent from './ReferencesModalContent/ReferencesModalContent'

export default {
  name: 'ReferencesModalModal',
  components: {
    BaseModal,
    BaseModalControls,
    ReferencesModalContent
  },
  props: {
    candidate: {
      type: Object,
      default: () => {}
    },
    link: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      variant: this.link ? 'link' : 'primary',
      classLink: this.link ? 'ml-n3' : ''
    }
  }
}
</script>
